// Form primitives for the notifications surface.
//
// The app has no shared Input/Button/Field component and does not want one --
// class strings are copied per surface, the way `DeleteSkillDialog` copies the
// same input class. These match `SettingsPage`'s, which is where this surface
// used to live, so nothing about the rendered form changed when it moved.

import { NOTE_CLASS } from "../../lib/ui.js";

export const inputCls =
    "min-h-[30px] rounded-[2px] border border-[color:var(--line)] bg-transparent px-[9px] text-[12px] leading-[1.18] text-[color:var(--ink)] outline-none placeholder:text-[color:var(--muted-soft)]";

export const primaryBtnCls =
    "h-[30px] rounded-[2px] border border-[color:var(--green)] bg-[color:var(--green-soft)] px-[10px] text-[11px] leading-[1.08] tracking-[0.04em] uppercase text-[color:var(--ink)] font-medium hover:border-[color:var(--green)] disabled:opacity-50 cursor-pointer";

export const secondaryBtnCls =
    "h-[30px] rounded-[2px] border border-[color:var(--line)] bg-transparent px-[10px] text-[11px] leading-[1.08] tracking-[0.04em] uppercase text-[color:var(--muted)] hover:text-[color:var(--ink)] disabled:opacity-50 cursor-pointer";

export function FormField({ label, hint, required = false, children }) {
    return (
        <label className="grid gap-[4px]">
            <span className={NOTE_CLASS}>
                {label}
                {/* On the field itself. It used to be a line at the foot of the
                    dialog naming the first outstanding field, which read as an
                    error about whichever field you were in. */}
                {required ? (
                    <span className="text-[color:var(--muted-soft)]" aria-hidden="true">
                        {" *"}
                    </span>
                ) : null}
            </span>
            {children}
            {hint ? <span className={`${NOTE_CLASS} text-[10px]`}>{hint}</span> : null}
        </label>
    );
}

// No "saved" state: the dialog that owns this closes on success, so a
// confirmation here could never be read. It is shown on the panel instead.
//
// It no longer says WHY the submit is disabled: that line named the first
// outstanding field, so typing a name surfaced "Enter the Slack webhook URL"
// underneath. Required fields are marked on the fields; per-field validation
// still speaks up once there is something to judge.
export function StatusLine({ status, error }) {
    if (status === "saving") {
        return <span className={`${NOTE_CLASS} text-[11px]`}>Saving...</span>;
    }
    if (error) {
        return <span className="text-[11px] text-red-400">{error}</span>;
    }
    return <span aria-hidden="true">&nbsp;</span>;
}
